module.exports = __webpack_public_path__ + "img/sos-sq.95c7dc99.svg";